// src/constants/colorMap.ts
export const COLOR_MAP: Record<string, string> = {
  A: '#8dd35f',
  R: '#ffff00',
  N: '#00ff00',
  D: '#ff0000',
  C: '#FFEA00',
  E: '#ff7f00',
  Q: '#7fff00',
  G: '#C4C4C4',
  H: '#7f00ff',
  I: '#00ff7f',
  L: '#007fff',
  K: '#BB99FF',
  M: '#7f7f7f',
  F: '#ff00ff',
  P: '#7f3f00',
  S: '#3fff7f',
  T: '#3f7fff',
  W: '#000000',
  Y: '#7f007f',
  V: '#00ff3f',
  '-': '#ffffff',
  'Гидрофобные': '#67E4A6',
  'Отрицательно заряженные': '#FCCAC',
  'Положительно заряженные': '#80BFFF',
  'Цистеин': '#FFEA00',
};
